import "./PlanetFox.css";

/**
 * 행성에 앉은 여우. 읽은 책이 FOX_UNLOCK 권을 넘으면 여행자 옆에 와서 앉는다.
 *
 * 여행자와 같은 규칙으로 무루가 직접 그린다 — 어느 동화의 그림을 옮기거나
 * 그 이름을 빌리지 않는다. 앉은 자세, 세운 귀, 감아 놓은 꼬리면 여우로 읽힌다.
 *
 * 행성 요소 안에 넣는다. 행성이 떠오르는 움직임을 같이 타야 발이 땅에서
 * 떨어져 보이지 않는다. 여행자는 꼭대기에 서고 여우는 왼쪽 비탈에 앉는다 —
 * 둘을 같은 자리에 두면 겹친다.
 */
export default function PlanetFox({ size = "home" }) {
  return (
    <span className={`fox fox-${size}`} aria-hidden="true">
      <svg viewBox="0 0 44 40" width="100%" height="100%">
        {/* 꼬리 — 몸 뒤에서 감아 올린다. 끝만 하얗다 */}
        <path d="M13 34 C4 34 2 27 6 22 C7.6 26.6 10.6 29.4 14.6 30.2 Z" fill="#d98b4a" />
        <path d="M6 22 C6.6 19.6 8.4 18 10.2 17.6 C9.6 19.6 9 21 8.8 23.2 Z" fill="#f3e6d4" />
        {/* 몸 */}
        <path d="M16 34 C13.6 30 14.6 24.4 18.6 21.8 C22.6 19.2 27.4 20.6 28.8 24.6 C30 28 29 31.6 27.4 34 Z" fill="#e2924c" />
        {/* 앞다리 */}
        <rect x="19.4" y="30.6" width="3" height="4" rx="1.4" fill="#c97f3f" />
        <rect x="24.4" y="30.6" width="3" height="4" rx="1.4" fill="#c97f3f" />
        {/* 가슴털 */}
        <path d="M22.6 26.4 C24.8 26.4 26 28 26 30.4 C26 32.4 24.8 34 22.6 34 C20.6 34 19.4 32.4 19.4 30.4 C19.4 28 20.6 26.4 22.6 26.4Z" fill="#f3e6d4" />
        {/* 귀 */}
        <path d="M18.6 16.6 L17.4 10.6 L22.2 13.8 Z" fill="#e2924c" />
        <path d="M19.2 15.2 L18.6 12 L21 13.8 Z" fill="#8f4f44" />
        <path d="M29.6 16.2 L31.4 10.4 L26.4 13.2 Z" fill="#e2924c" />
        <path d="M29.4 14.8 L30.4 11.8 L27.8 13.4 Z" fill="#8f4f44" />
        {/* 머리 */}
        <path d="M24 12.4 C28.8 12.4 32.2 15.6 32.2 19.4 C32.2 23 28.8 25.6 24 25.6 C19.4 25.6 16 23 16 19.4 C16 15.6 19.4 12.4 24 12.4Z" fill="#e79a54" />
        {/* 주둥이와 코 */}
        <path d="M24 19.4 C26.4 19.4 28.2 21 28.2 22.6 C28.2 24.2 26.4 25.4 24 25.4 C21.6 25.4 19.8 24.2 19.8 22.6 C19.8 21 21.6 19.4 24 19.4Z" fill="#f3e6d4" />
        <ellipse cx="24" cy="21.6" rx="1.5" ry="1.1" fill="#3a2418" />
        {/* 눈 */}
        <ellipse cx="20.8" cy="18.4" rx="1.1" ry="1.3" fill="#3a2418" />
        <ellipse cx="27.2" cy="18.4" rx="1.1" ry="1.3" fill="#3a2418" />
      </svg>
    </span>
  );
}
